import {
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Modal from '../../../components/Modal';
import { showToast } from '../../../components/ToastMsg';
import Pagination from '../../../components/Pagination';
import { getWithdrawalsList, updateWithdrawalStatus } from '../../../redux/features/withdrawals/withdrawalsService';
import DropdownwithValue from '../../../components/DropdownValue';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

function formatDateTime(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date)) return null; // invalid date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const Status = [
    {id: 'Pending', name: 'Pending'},
    {id: 'Approved', name: 'Approved'},
    {id: 'Rejected', name: 'Rejected'},
]
const WithdrawalRequests = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isWithdrawalsLoading, pageCount, withdrawals } = useSelector((state) => state.withdrawal.withdrawalsList);

    const [withdrawDate, setWithdrawDate] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState({
        id: null,
        name: null
    });
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const fetchAllWithdrawals = useCallback(
        (filters = {}) => {
            const params = {
                date: withdrawDate && withdrawDate,
                withdrawal_request_status: selectedStatus && selectedStatus.id,
                status: true,
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(getWithdrawalsList(params));
        },
        [dispatch, withdrawDate, selectedStatus, skip]
    );

    useEffect(() => {
        fetchAllWithdrawals();
    }, [fetchAllWithdrawals]);

    const handleStatus = (option) => {
        setSelectedStatus({id: option.id, name: option.name});
    }

    const handleView = async (id) => {
        navigate(`/admin/withdrawals/${id}`);
    };

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Withdrawals{' '}
                    </h1>
                </div>
                <div className={`form-input-col ${styles.filterInput}`}>
                    <div className={`form-input-group`}>
                        <input
                            type="date"
                            value={withdrawDate || ''}
                            onChange={(e) => setWithdrawDate(e.target.value)}
                            className={`form-input-default`}
                            placeholder="Date"
                        />
                    </div>
                </div>
                  <div className={`form-input-col`}>
                    <div className={`form-input-group`}>
                        <DropdownwithValue
                                  options={Status}
                                  placeholder='Select Status'
                                  onSelect={handleStatus}
                                  value={selectedStatus.name}
                                />
                    </div>
                </div>
            </div>
            <div>
                {isWithdrawalsLoading ? (
                    <TableSkeleton
                        columns={['Date', 'Name', 'Bank Name', 'Account No', 'Status', 'Amount', 'Actions']}
                        rowCount={10}
                        height={20}
                    />
                ) : withdrawals.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Date</th>
                                    <th>Name</th>
                                    <th>Bank Name</th>
                                    <th>Account No</th>
                                    <th>Status</th>
                                    <th className={styles.priceTd}>Amount</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {withdrawals?.map((withdraw) => (
                                    <tr key={withdraw.id}>
                                        <td className={`tdataColumnOne`}>{formatDateTime(withdraw?.created_at)}</td>
                                        <td>{withdraw?.wallet?.user?.full_name}</td>
                                        <td>{withdraw?.bank_name}</td>
                                        <td>{withdraw?.account_number}</td>
                                        <td className={styles.smTd}>{withdraw?.withdrawal_request_status}</td>
                                        <td className={styles.priceTd}>{withdraw?.amount.toFixed(2)}</td>
                                        <td className={`actionsBtn`}>                                           
                                                <button className={`btn-primary`} onClick={() => {
                                                    handleView(withdraw.id);
                                                }}
                                                style={{backgroundColor: 'var(--green)', borderColor: 'var(--green)'}}>
                                                    View
                                                </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`} style={{marginTop: '20px'}}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WithdrawalRequests;
